import React, { useEffect, useState } from 'react'
import { css } from '@linaria/core';
import { styled } from '@linaria/react'
import Text from '@components/Text';

interface ErrorContainerProps{
  isShow?: boolean;
}
const FormErrorContainer = styled.div<ErrorContainerProps>`
  display: ${props => props.isShow ? "block" : "none"};
  margin-top:13px;
`;
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 5px;
  @media screen and (min-width: 768px) {
    margin: 0 23px;
  }
`;
const SvgContainer = styled.svg<SvgContainerProps>`
  display:block;
  color: ${props => props.color ? props.color : "#000"}
`;

const ErrorMessageCss = css`
  display: block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #434343;
  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
`;

const InnerErrorMessageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface SvgContainerProps{
  color?: string;
}
const Icon = ({color}:SvgContainerProps) =>{
  return (
    <SvgContainer
      color={color}
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.5 16.5C13.6421 16.5 17 13.1421 17 9C17 4.85786 13.6421 1.5 9.5 1.5C5.35786 1.5 2 4.85786 2 9C2 13.1421 5.35786 16.5 9.5 16.5ZM9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z'
        fill='currentColor'
      />
      <path
        d='M9.89373 11.6255L10.2125 5.24906C10.2329 4.84156 9.90801 4.5 9.5 4.5C9.09199 4.5 8.76708 4.84156 8.78745 5.24906L9.10627 11.6255C9.11676 11.8353 9.28993 12 9.5 12C9.71007 12 9.88324 11.8353 9.89373 11.6255Z'
        fill='currentColor'
      />
      <circle cx='9.5' cy='13.5' r='0.75' fill='currentColor' />
    </SvgContainer>
  );
}
interface PromoMessageBoxProps{
  color?: string;
  type?: string;
}
export const PromoMessageBox = ({color,type}:PromoMessageBoxProps) => {
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [iconColor, setIconColor] = useState<string>("");
  

  useEffect(()=>{
    if(type === 'invalid') {
      setErrorMsg('Promo Code is Invalid');
      setIconColor('#C50000');
    } else if(type === 'error') {
      setErrorMsg('Opps, somethings is wrong.');
      setIconColor('#C50000');
    } else if(type === 'invalidNric') {
      setErrorMsg('Please specify a valid NRIC number');
      setIconColor('#C50000');
    } else if(type === 'unmatchNric') {
      setErrorMsg('Please enter NRIC that matches with MyInfo');
      setIconColor('#C50000');
    } else if(type === 'success') {
      setErrorMsg('Promo Code has been applied Successfully');
      setIconColor('#00AC95');
    } else {
      setErrorMsg('');
      setIconColor('');
    }
  },[type]);
 
  return (
    <FormErrorContainer isShow={type !== ""}>
      <InnerErrorMessageContainer>
        <IconContainer>
          <Icon color={iconColor}/>
        </IconContainer>
        <Text className={ErrorMessageCss} align={'center'}>{errorMsg}</Text>
      </InnerErrorMessageContainer>
    </FormErrorContainer>
  )
}
